module.exports = __webpack_public_path__ + "static/media/button_plus_light.3d190172.svg";